var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityCompanionCarerDiscount = function SvgAccessibilityCompanionCarerDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.749 16.097a1 1 0 1 0-1.415 1.414 1 1 0 0 0 1.415-1.414zm2.221-3.712 2.883 9.137m2.672-4.62a1 1 0 1 0-1.42 1.41 1 1 0 0 0 1.42-1.41z"
  }), /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m9.897 8.732-8.774 8.773a.963.963 0 0 0 0 1.359l2.415 2.414c.2.201.517.224.743.053a3.141 3.141 0 0 1 4.388 4.388.566.566 0 0 0 .053.743l2.42 2.415a.963.963 0 0 0 1.358 0l8.547-8.547"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m8.732 9.897 8.773-8.774a.963.963 0 0 1 1.359 0l2.414 2.415c.201.2.224.517.053.743a3.141 3.141 0 0 0 4.388 4.388.566.566 0 0 1 .743.053l2.415 2.42a.963.963 0 0 1 0 1.358l-8.547 8.547M12.892 5.846l1.193 1.189m1.812 1.81 1.634 1.64m1.953 1.953 1.64 1.64m1.81 1.812 1.246 1.245"
  })))));
};
export default SvgAccessibilityCompanionCarerDiscount;